export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const USER_INFO = 'USER_INFO'
export const PERMISSION = 'PERMISSION'
export const AUTH_ROLE = 'AUTH_ROLE'